import React from "react";
import { CheckCircle } from "lucide-react";

const TrustworthyAISection = () => {
  const principles = [
    "GDPR and ISO-ready AI processes",
    "Zero data sharing outside your environment",
    "Full auditability and policy-based control",
    "AI ethics and accountability baked into design"
  ];

  return (
    <section className="py-16 md:py-20 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-5xl mx-auto space-y-8">
          <div className="text-center space-y-4">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground">
              Trustworthy AI and Compliance
            </h2>
            <p className="text-lg text-muted-foreground max-w-4xl mx-auto">
              AuraXP is built on the principles of transparency, fairness, and security. Every AI decision is explainable, traceable, and aligned with enterprise governance standards.
            </p>
          </div>

          <div className="space-y-4">
            {principles.map((principle, index) => (
              <div key={index} className="flex items-start gap-4 bg-muted/50 p-4 rounded-lg">
                <div className="flex-shrink-0 mt-1">
                  <CheckCircle className="w-6 h-6 text-[#8932c8]" />
                </div>
                <p className="text-lg text-foreground font-medium">{principle}</p>
              </div>
            ))}
          </div>

          <div className="text-center pt-6">
            <p className="text-xl md:text-2xl font-bold text-[#8932c8]">
              Trust is not an add-on, it's engineered into AuraXP's core.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustworthyAISection;
